<template>
  <ubi-page-container wide-main-content>
    <ubi-panel>
      <el-row>
        <el-col :lg="24">
          {{$t('socialNetworks.newPost.introText')}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="24">
          &nbsp;
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="24">
          &nbsp;
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="24">
          &nbsp;
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="12">
            {{$t('socialNetworks.newPost.createPostLabel')}}
        </el-col>
        <el-col :lg="12">
            <el-select v-model="typeSelection" :placeholder="$t('socialNetworks.newPost.selectPostType')" @change="displayAnnonces()">
              <el-option value="annonce" :label="$t('socialNetworks.newPost.fromAd')">{{$t('socialNetworks.newPost.fromAd')}}</el-option>
              <el-option value="bien_vendu" :label="$t('socialNetworks.newPost.fromSoldProperty')" v-if="universe !== 'VO' && possedeBiensVendus === true">{{$t('socialNetworks.newPost.fromSoldProperty')}}</el-option>
              <el-option value="post_editorial" :label="$t('socialNetworks.newPost.editorial')" v-if="possedeEdito">{{$t('socialNetworks.newPost.editorial')}}</el-option>
              <el-option value="post_editorial_from_modele" :label="$t('socialNetworks.newPost.fromPostTemplate')" v-if="possedeEdito">{{$t('socialNetworks.newPost.fromPostTemplate')}}</el-option>
            </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="24">
          &nbsp;
        </el-col>
      </el-row>
      <el-row v-if="displayBlockAnnonces === true">
        <el-col :lg="12">
          {{$t('socialNetworks.newPost.selectRelatedAd')}}
        </el-col>
        <el-col :lg="12">
          <el-autocomplete
              v-model="selectedPostValue"
              :fetch-suggestions="searchAnnonces"
              @select="selectAnnonce()"
              clearable
          >
          </el-autocomplete>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="24">
          &nbsp;
        </el-col>
      </el-row>
      <el-row v-if="displayBlockEditorial && selectedPost === null && selectedPostValue === null" style="padding-top: 25px;">
        <el-col :lg="6">
          &nbsp;
        </el-col>
        <el-col :lg="4" style="padding-bottom: 10px;text-align: center">
          <router-link :to="{ name: 'new-post-editorial', params: { network: 'google' } }">
            <img
              alt=""
              :src="require(`@/assets/1200px-Google-My-Business_logo.svg.png`)"
              width="80"
              style="padding-bottom: 10px;"
          /></router-link>
        </el-col>
        <el-col :lg="4" style="padding-bottom: 10px;text-align: center">
          <router-link :to="{ name: 'new-post-editorial', params: { network: 'instagram' } }">
            <img
              alt=""
              :src="require(`@/assets/2048px-Instagram_icon.png`)"
              width="80"
              style="padding-bottom: 10px;"
          /></router-link>
        </el-col>
        <el-col :lg="4" style="padding-bottom: 10px;text-align: center">
          <router-link :to="{ name: 'new-post-editorial', params: { network: 'facebook' } }">
            <img
              alt=""
              :src="require(`@/assets/facebook-logo-5-1.png`)"
              width="80"
              style="padding-bottom: 10px;"
          /></router-link>
        </el-col>
        <el-col :lg="6">
          &nbsp;
        </el-col>
      </el-row>
<!--      <el-row  v-if="displayBlockEditorial && selectedPost === null && selectedPostValue === null">-->
<!--        <el-col :lg="6">&nbsp;</el-col>-->
<!--        <el-col :lg="4" style="padding-bottom: 10px;text-align: center">-->
<!--          <router-link :to="{ name: 'new-post-editorial', params: { network: 'google' } }">Google</router-link>-->
<!--        </el-col>-->
<!--        <el-col :lg="4" style="padding-bottom: 10px;text-align: center">-->
<!--          <router-link :to="{ name: 'new-post-editorial', params: { network: 'instagram' } }">Instagram</router-link>-->
<!--        </el-col>-->
<!--        <el-col :lg="4" style="padding-bottom: 10px;text-align: center">-->
<!--          <router-link :to="{ name: 'new-post-editorial', params: { network: 'facebook' } }">Facebook</router-link>-->
<!--        </el-col>-->
<!--        <el-col :lg="6">&nbsp;</el-col>-->
<!--      </el-row>-->
    </ubi-panel>

    <ubi-panel v-if="selectedPostValue != null && selectedPost != null">
      <el-row >
        <el-col :lg="12">
          <div v-if="selectedPost.photoPrincipale != null">
            <img width="250"
                 alt=""
                 :src="selectedPost.photoPrincipale.url_miniature"
                 :srcset="selectedPost.photoPrincipale.url_miniature"
            />
          </div>
          <div v-else style="text-align: center;"><ubi-icon class="no-photo" name="camera" size='250' /></div>
        </el-col>
        <el-col :lg="12">
          {{$t('socialNetworks.newPost.title')}}: {{selectedPost.titre}}<br>
          {{$t('socialNetworks.newPost.reference')}} : {{selectedPost.reference}}<br>
          {{$t('socialNetworks.newPost.price')}} : {{selectedPost.prixDisplay}}<br>
          <br>
          <el-col :lg="24" v-if="alreadyBroadcasted === true" style="color: #d24554">
            {{$t('socialNetworks.newPost.alreadyPosted')}} <span v-if="allRSPublished">{{$t('socialNetworks.newPost.noEditable')}}</span>
          </el-col>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="text-right">
            <router-link :to="{ name: 'social-posts' }" style="margin-right: 10px;">
              <el-button>{{$t('socialNetworks.newPost.cancel')}}</el-button>
            </router-link>
            <router-link v-if="typeSelection==='bien_vendu'" :to="{ name: 'edit-bien-vendu', params: { id: selectedPost.id, linkSocialPosts: true } }" >
              <el-button type="primary" v-if="alreadyBroadcasted" :disabled="allRSPublished">{{$t('socialNetworks.newPost.editPost')}}</el-button>
              <el-button type="primary" v-else>{{$t('socialNetworks.newPost.validateAndContinue')}}</el-button>
            </router-link>
            <router-link v-else :to="{ name: 'manage-posts', params: { id: selectedPost.id, linkSocialPosts: true } }">
              <el-button type="primary" v-if="alreadyBroadcasted" :disabled="allRSPublished">{{$t('socialNetworks.newPost.editPost')}}</el-button>
              <el-button type="primary" v-else>{{$t('socialNetworks.newPost.validateAndContinue')}}</el-button>
            </router-link>
          </div>
        </el-col>
      </el-row>
    </ubi-panel>
  </ubi-page-container>
</template>

<script>
import UbiPanel from '@/components/Panel'
import { getPostsAutocompletion } from '@/services/posts'
import socialPostPublicationStatus from '@/mixins/socialPostPublicationStatus'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiIcon from '@/components/Icon.vue'

export default {
  name: 'SocialPostsNew',
  components: { UbiIcon, UbiPageContainer, UbiPanel },
  mixins: [socialPostPublicationStatus],
  data () {
    return {
      loading: false,
      typeSelection: null,
      selectedPostValue: null,
      selectedPost: null,
      posts: null,
      filter: {
        status: 'A',
        search: '',
        page: 1,
        perPage: 10
      },
      filterAnnonces: null,
      alreadyBroadcasted: false,
      displayBlockAnnonces: false,
      displayBlockEditorial: false,
      allRSPublished: false
    }
  },
  computed: {
    possedeBiensVendus () {
      return this.sitimmoUser.soldProductsOption
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeEdito () {
      return this.sitimmoUser.optionEdito
    }
  },
  methods: {
    displayAnnonces () {
      if (this.typeSelection === 'annonce') {
        this.filter.etat = 'A'
        this.displayBlockAnnonces = true
        this.displayBlockEditorial = false
      }
      if (this.typeSelection === 'bien_vendu') {
        this.filter.etat = 'V'
        this.displayBlockAnnonces = true
        this.displayBlockEditorial = false
      }
      if (this.typeSelection === 'post_editorial') {
        this.$router.push({ name: 'new-post-editorial' })
      }
      if (this.typeSelection === 'post_editorial_from_modele') {
        this.$router.push({ name: 'post-editorial-modeles' })
      }
    },
    async searchAnnonces (queryString, cb) {
      this.filter.search = queryString
      const results = await getPostsAutocompletion(this.filter)
      this.posts = results
      cb(results)
    },
    async selectAnnonce () {
      this.alreadyBroadcasted = false
      const search = this.posts.find(element => element.value === this.selectedPostValue)
      if (search) {
        this.selectedPost = search.post
        const idPost = this.selectedPost.id
        if (this.selectedPost.id) {
          const status = await this.checkPostPublicationStatus(idPost, this.typeSelection)
          this.alreadyBroadcasted = status.hasRSPublished
          this.allRSPublished = status.allRSPublished
        }
      }
    }
  }
}
</script>
